"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCustomerData = checkCustomerData;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var translation_1 = __importDefault(require("@src/services/translation"));
function checkCustomerData(formData) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!((_a = formData.city) === null || _a === void 0 ? void 0 : _a.length)) {
        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidCity'));
        console.warn('City is invalid', formData.city);
        return false;
    }
    else if (!((_b = formData.gender) === null || _b === void 0 ? void 0 : _b.length)) {
        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidGender'));
        console.warn('Gender is invalid', formData.gender);
        return false;
    }
    else if (!((_c = formData.street) === null || _c === void 0 ? void 0 : _c.length)) {
        console.warn('Street is invalid', formData.street);
        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidStreetName'));
        return false;
    }
    else if (!((_d = formData.houseNumber) === null || _d === void 0 ? void 0 : _d.length)) {
        console.warn('Housenumber is invalid', formData.houseNumber);
        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidHousenumber'));
        return false;
    }
    else if (!((_e = formData.zipCode) === null || _e === void 0 ? void 0 : _e.length)) {
        console.warn('PLZ is invalid', formData.zipCode);
        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidZIP'));
        return false;
    }
    else if (((_f = formData.zipCode) === null || _f === void 0 ? void 0 : _f.length) < 3) {
        console.warn('PLZ is wrong', formData.zipCode);
        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidZIP'));
        return false;
    }
    else if (!((_g = formData.dateOfBirth) === null || _g === void 0 ? void 0 : _g.length) || ((_h = formData.dateOfBirth) === null || _h === void 0 ? void 0 : _h.length) < 4) {
        console.warn('dateOfBirth is invalid', formData.dateOfBirth);
        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('noValidBirthday'));
        return false;
    }
    return true;
}
